import React from 'react';

import Loader from 'components/Loader';
import { insights as TEXT } from 'locales/en';
import { CURRENCY_SYMBOL } from 'utils/transform';

const TopDonation = ({ isLoading, data }) => {
  return (
    <div className="border-b border-javelin-gray-border p-5 lg:p-7 relative h-28">
      {isLoading ? (
        <Loader
          isBarVisible={false}
          fullScreen={false}
          className="pt-3 h-full justify-center"
        />
      ) : (
        <>
          <p className="mb-2 text-sm text-javelin-gray-dark text-opacity-40">
            {TEXT.donations.top}
          </p>
          {data.shopper_name ? (
            <div className="text-sm h-8 flex flex-row">
              <span className="w-24 lg:min-w-32 lg:w-auto truncate mr-1">
                {data.shopper_name} {data.shopper_surname}
              </span>
              <span className="w-24 truncate font-bold min-w-16 lg:min-w-28 lg:w-auto mr-1">
                {CURRENCY_SYMBOL.EUR}
                {data.total}
              </span>
              <span className="w-auto truncate">{data.storeName}</span>
            </div>
          ) : (
            <p className="text-sm text-javelin-gray-dark">-</p>
          )}
        </>
      )}
    </div>
  );
};

export default TopDonation;
